import React from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import PageHeader from "../shared/PageHeader";
import RunsList from "./RunsList";
import RunDetail from "./RunDetail";
import Lohnjournal from "./Lohnjournal";
import Lohnkonto from "./Lohnkonto";
import EmployeeChecklist from "./EmployeeChecklist";
import EmployeeDocuments from "./EmployeeDocuments";
import PayrollFilings from "./PayrollFilings";
import CostRates from "./CostRates";
import PayrollSettings from "./PayrollSettings";

const BASE = "/user/accounting/payroll";

const TABS = [
  ["runs", "Payroll runs", RunsList],
  ["journal", "Lohnjournal", Lohnjournal],
  ["lohnkonto", "Lohnkonto", Lohnkonto],
  ["employees", "Employee checklist", EmployeeChecklist],
  ["documents", "Certificates", EmployeeDocuments],
  ["filings", "Filings", PayrollFilings],
  ["cost-rates", "Cost rates", CostRates],
  ["settings", "Payroll settings", PayrollSettings]
];

// Module M6 — Lohnbuchhaltung. Sub-pages are matched here; the router only knows /payroll.
const PayrollHome = () => {
  const { t } = useTranslation("accounting");
  const history = useHistory();
  const location = useLocation();
  const active = TABS.find(([key]) => location.pathname === `${BASE}/${key}`)?.[0] || "runs";
  return (
    <div>
      <PageHeader
        title={t("Payroll")}
        subtitle={t("Monthly Lohnlauf, Lohnjournal, Lohnkonto, filings and employer settings")}
      />
      <Tabs
        activeKey={active}
        onChange={key => history.push(key === "runs" ? BASE : `${BASE}/${key}`)}
        items={TABS.map(([key, label, Component]) => ({
          key,
          label: t(label),
          children: <Component />
        }))}
        destroyInactiveTabPane
      />
    </div>
  );
};

const PayrollRuns = () => (
  <Switch>
    <Route path={`${BASE}/runs/:id`} component={RunDetail} />
    <Route path={BASE} component={PayrollHome} />
  </Switch>
);

export default PayrollRuns;
